// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAuth } from 'firebase/auth'
import { getFirestore, doc, getDoc, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore'
import { getMyUserId } from './FirebaseUserWrapper'

const auth = getAuth(firebaseApp)
const db = getFirestore(firebaseApp)

/*
 * 通知関係
 */
/**
 * updateNotification:
 *   /users/{userId}/notifications/{notificationId}のデータを更新
 *  下記paramのemailFlag or viewFlagが更新された場合に発動
 *   @param {string}  creatingUserId 通知を作成したuser
 *   @param {string}  targettedUserId 対象のUser
 *   @param {string}  targettedTreeId 対象が発生したTreeId
 *   @param {string}  targettedIssue 対象が発生したIssue
 *   @param {string}  notifiedQuestion 通知の内容 質問 45文字まで
 *   @param {string}  type '回答' or '質問'
 *   @param {boolean} viewFlag 対象のUserが通知を閲覧したらtrue
 *   @param {createdAt} Date 作成Userが通知を作ったタイミング
 *   @return {object} updateしたデータを返す
 */
export async function updateNotification (data) {
  const userId = await getMyUserId()
  data.updatedAt = serverTimestamp()
  const notificationsDocRef = doc(db, 'uids/' + userId + '/notifications', data.id)
  try {
    const notificationsRef = await updateDoc(notificationsDocRef, data)
    return notificationsRef
  } catch (err) {
    throw err
  }
}

/*
 * View数関係
 */

/**
  * recordTreeViewer:
  *   /treesV2/{treeId}/viewers/{uid}にuidを登録
  */
export async function recordTreeViewer (treeId) {
  const uid = auth.currentUser.uid
  // userの存在をチェック
  const viewersDocRef = doc(db, 'treesV2/' + treeId + '/viewers', uid)
  const userDoc = await getDoc(viewersDocRef)
  if (userDoc.exists()) { return }

  // 存在しなければ登録
  const nowTime = serverTimestamp()
  let uidData = {
    createdAt: nowTime
  }
  try {
    await setDoc(viewersDocRef, uidData)
  } catch (err) {
    throw err
  }
}
/**
  * getViewsOfTree:
  *   /views/{uid}/trees/{treeId}からviews情報を取得
  *   @return {Number} uu数を返す
  */
export async function getViewsOfTree (treeId, uid) {
  const viewsDocRef = doc(db, 'views/' + uid + '/trees', treeId)
  const viewsDoc = await getDoc(viewsDocRef)
  if (!viewsDoc.data()) { return 0 }
  const views = viewsDoc.data().views
  return views
}



// WEBPACK FOOTER //
// ./src/api/FirebaseViewWrapper.js